<template>
<div>
    <v-data-table :headers="headers" :items="invoices" :items-per-page="5" class="elevation-0">
        <template v-slot:item.currency="{ item }">
            {{item.currency == 'USD' ? '$' : item.currency == 'INR' ? '₹' : '€'}} {{item.amount}}
        </template>

    
        <template v-slot:item.date="{ item }">
            {{ Moment(item.date) }}
        </template>
        <template v-slot:item.dueDate="{ item }">
            {{Moment(item.dueDate)}}
        </template>
        <template v-slot:item.status="{ item }">
            <v-chip :color="item.status == 'paid' ? 'success' : 'orange'" small label outlined>
                {{item.status}}
            </v-chip>
        </template>
        <template v-slot:item.action="{ item }">
            <v-btn v-if="item.status != 'paid'" @click="view(item.id)" small color="primary" class="mr-2">
                View / Pay
            </v-btn>
            <v-btn v-else small @click="view(item.id)" color="success">
                View / Download
            </v-btn>
        </template>
    </v-data-table>
</div>
</template>

<script>
import {
    mapActions
} from 'vuex'
import moment from 'moment'
export default {
    props: ['invoices'],
    data() {
        return {
            loading: false,
            headers: [{
                    text: 'Invoice ID',
                    align: 'left',
                    sortable: false,
                    value: 'displayId',
                },
                {
                    text: 'Date',
                    value: 'date'
                },
                {
                    text: 'Due date',
                    value: 'dueDate'
                },
                {
                    text: 'Amount',
                    value: 'currency'
                },
                {
                    text: 'Status',
                    value: 'status'
                },
                {
                    text: 'Action',
                    align: 'center',
                    value: 'action'
                },
            ],
        }
    },
    methods: {
        ...mapActions(['GetResponse']),

        view(data){
            window.open(`https://billing.cloudstuff.tech/invoices/pay/${data}`, "_blank");
        },
        Moment(date) {
            return moment(date).format('MMMM Do YYYY');
        }
    },
}
</script>

<style scoped>
.active {
    color: green !important;
    caret-color: green !important;
    border-color: green !important;
}
</style>
